module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-three-smc/key-3-2020.svg?v=c6bdde30";